import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEnter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEnter"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V9H9V3H21V21ZM14.25 14.25H10.75V12.5L7.25 15L10.75 17.5V15.75H15.75V9.75H14.25V14.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEnter;
